export const OPERATOR_CONTAINS = 'contains';
export const OPERATOR_GREATERTHAN = 'greaterThan';
export const OPERATOR_LESSTHAN = 'lessThan';
export const OPERATOR_EQUAL = 'eq';
export const OPERATOR_BEFOREORON = 'beforeOrOn';
export const OPERATOR_BEFORE = 'before';
export const OPERATOR_AFTERORON = 'afterOrOn';
export const OPERATOR_AFTER = 'after';
export const TYPE_INPUT = 'INPUT';
export const TYPE_CHECKBOX = 'CHECKBOX';
export const TYPE_DATE = 'DATE';
export const TYPE_DATETIME = 'DATETIME';
export const TYPE_DROPDOWN = 'DROPDOWN';

export enum OPERATORS {
  CONTAINS = 'contains',
  GREATERTHAN = 'greaterThan',
  EQUAL = 'eq',
  BEFOREORON = 'beforeOrOn',
  BEFORE = 'before',
  AFTERORON = 'afterOrOn',
  AFTER = 'after',
}

export enum TYPES {
  INPUT = 'INPUT',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  DROPDOWN = 'DROPDOWN',
}

export const paginationComponentOptions = {
  rowsPerPageText: 'Resultados por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

const getFilterUrlFromFilterValues = (filters: any, filtersConfig: any) => {
  if (Object.entries(filters).length === 0) return '';

  let url = '';
  let i = 0;

  for (let prop in filters) {
    if (filters[prop]) {
      let operatorItem = filtersConfig.find((e: any) => e.name === prop);
      let operator = operatorItem ? operatorItem.operator : OPERATOR_CONTAINS;
      let search = filters[prop];
      if (operator == OPERATOR_CONTAINS) {
        search = '*' + filters[prop] + '*';
      }
      url += `&columns[${i}][data]=${prop}&columns[${i}][search][value]=${search}`;
      i++;
    }
  }

  return url;
};

const getSortUrl = (sortOrder: any) => {
  let url = '';
  if (sortOrder.column) {
    url = `&sort[0][id]=${sortOrder.column.sortField}&sort[0][direction]=${sortOrder.direction}`;
  }
  return url;
};

export const getDatagridUrlParams = (
  skip: number,
  limit: number,
  filters: any,
  filtersConfig: any,
  order: any
) => {
  let params = `&start=${skip}&length=${limit}`;

  params += getFilterUrlFromFilterValues(filters, filtersConfig);

  params += getSortUrl(order);

  return params;
};

export interface DropdownIfc {
  label: string;
  value: string;
  id?: string;
}

export const initializeColumn = (name: string, prop: string, grow: number) => {
  let _ret = {
    name: name,
    selector: (row: any) => `${row[prop]}`,
    sortable: true,
    sortField: prop,
    filterable: true,
    grow: grow,
  };

  return _ret;
};

export const initializeColumnWithFormat = (
  name: string,
  prop: string,
  formatFn: (row: any) => string,
  grow: number
) => {
  let _ret = {
    name: name,
    selector: (row: any) => `${row[prop]}`,
    sortable: true,
    sortField: prop,
    filterable: true,
    format: (row: any) => formatFn(row),
    grow: grow,
  };

  return _ret;
};

export const InitializeFilter = {
  Input: (operator: string, name: string, placeholder: string, grow?: number) => {
    return {
      type: TYPES.INPUT,
      operator: operator,
      grow: grow,
      placeholder: placeholder,
      name: name,
    };
  },
  Dropdown: (
    operator: string,
    name: string,
    placeholder: string,
    contextForDropdown: any[],
    grow?: number
  ) => {
    return {
      type: TYPES.DROPDOWN,
      operator: operator,
      grow: grow,
      placeholder: placeholder,
      name: name,
      contextForDropdown: contextForDropdown,
    };
  },
  CheckBox: (operator: string, name: string, label: string, grow?: number) => {
    return {
      type: TYPES.CHECKBOX,
      operator: operator,
      grow: grow,
      name: name,
      labelForCheckBox: label,
      checkBoxValue: '1',
    };
  },
  DateTime: (operator: string, name: string, placeholder: string, grow?: number) => {
    return {
      type: TYPES.DATETIME,
      operator: operator,
      grow: grow,
      placeholder: placeholder,
      name: name,
    };
  },
};

export const prepareAppSelector = (_obj: any, key: string) => {
  if (_obj && _obj[key]) return _obj[key];
  else return {};
};
